import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Method to compare if the given pasword matches with the currently typed confirm password
 */
export function comparePasswords(control: AbstractControl): ValidationErrors | null {
    const password = control.get('password');
    const confirmPassword = control.get('passwordConfirmation');

    if (password?.value !== confirmPassword?.value) {
        confirmPassword?.setErrors({ ...confirmPassword.errors, passwordsDoNotMatch: true });
        return { passwordsDoNotMatch: true };
    }

    const errors = confirmPassword?.errors;
    if (errors) {
        delete errors['passwordsDoNotMatch'];
        confirmPassword?.setErrors(Object.keys(errors).length === 0 ? null : errors);
    }

    return null;
}
